import { ReactNode } from 'react';

import { Modal } from '@atom/mui';
import colors from '@atom/styles/colors';

type ConfirmDeleteModalProps = {
  open: boolean;
  title: string;
  children: ReactNode;
  onCancel: () => void;
  onConfirm: () => void;
  CancelButtonProps?: Record<string, unknown>;
  ConfirmButtonProps?: Record<string, unknown>;
};

const ConfirmDeleteModal = ({
  open,
  title,
  children,
  onCancel,
  onConfirm,
  CancelButtonProps,
  ConfirmButtonProps,
}: ConfirmDeleteModalProps) => {
  const confirmButtonProps = {
    sx: {
      background: colors.brand.red,
    },
    ...ConfirmButtonProps,
  };

  return (
    <Modal
      open={open}
      title={title}
      onCancel={onCancel}
      confirmButtonText="Delete"
      CancelButtonProps={CancelButtonProps}
      ConfirmButtonProps={confirmButtonProps}
      onConfirm={onConfirm}
    >
      {children}
    </Modal>
  );
};

export default ConfirmDeleteModal;
